import { createRouter, createWebHistory } from "vue-router";
import { practiceRegistration, patientRegistration, routes, valorumEnrollment } from '@/router/routes';
import { useAuthStore } from '@/stores/auth.store';
import AuthService from '@/services/auth.service';
import { useContextStore } from '@/stores/context.store';

const host = window.location.hostname.toLowerCase();
const parts = host.split('.');
const domainLength = 3; // route1.example.com => domain length = 3
const valorumEnrollmentHosts = [
  'apply.valorumpro.com',
  'www.apply.valorumpro.com',
  'demo.apply.valorumpro.com',
];

const finalRoutes = () => {
  let routesArr = [];
  if (valorumEnrollmentHosts.includes(host)) {
    routesArr = valorumEnrollment;
  } else if (parts.length === (domainLength - 1) || parts[0] === 'www') {
    routesArr = routes;
  } else if (parts[0] === 'patient') {
    routesArr = patientRegistration;
  } else if (parts[0] === 'practice') {
    routesArr = practiceRegistration;
  } else if (parts[0] === 'apply') {
    routesArr = valorumEnrollment;
  } else {
    // If you want to do something else just comment the line below
    routesArr = routes;
  }
  return routesArr;
};


const router = createRouter({
  history: createWebHistory(),
  routes: finalRoutes(),
  scrollBehavior(to, from, savedPosition) {
    // always scroll to top
    return { top: 0 }
  },
});

const title = "Patient Access Operations";

router.beforeEach(async (to, from, next) => {
  const nearestWithTitle = to.matched
    .slice()
    .reverse()
    .find((r) => r.meta && r.meta.title);

  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title + " | " + title || title;
  }

  const authStore = useAuthStore();
  const loggedIn = authStore.isAuthenticated;
  const token = AuthService.getToken();

  if (to.meta.guestOnly && loggedIn && token) {
    return next({ name: "Dashboard" });
  }

  if (!to.meta.authRequired) {
    return next();
  }

  if (loggedIn && token) {
    const contextStore = useContextStore();

    if (!contextStore.selectedProgram && !contextStore.loading) {
      await contextStore.loadContexts();
    }

    const moduleKey = to.meta.moduleKey as string | undefined;

    if (moduleKey && !contextStore.moduleEnabled(moduleKey) && !contextStore.isCaravelAdmin) {
      return next("/dashboard");
    }

    if (to.meta.caravelOnly && !contextStore.isCaravelAdmin) {
      return next("/dashboard");
    }

    if (to.meta.adminOnly && !contextStore.isAdminUser) {
      return next("/dashboard");
    }

    next();
  } else {
    next("/");
  }
});

export default router;
